import {jsonMember, jsonObject} from "typedjson";
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";
import {LoadedFile} from "./loaded-file";
import {PitUser} from "./pit-user";

/** Прикрепленный файл */

@jsonObject
export class PitFile extends DxGridRow {

  /** Идентификатор сущности к которой относится файл */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  fileEntityId: number;

  /** Имя файла с расширением */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  fileName: string;

  /** Идентификатор загруженного содержимого файла */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  fileId: number;

  /** Идентификатор типа прикрепленного файла из НСИ */
  @jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false })
  typeFileId: number;

  /** Идентификатор пользователя Системы, прикрепившего файл */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  attachUserId: number;

  /** ФИО пользователя Системы, прикрепившего файл */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  attachUserName: string;

  /** Должность пользователя Системы, прикрепившего файл */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  attachUserPost: string;

  /** Комментарий к прикрепленному файлу */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  comment: string;

  /** Прикрепление файла удалено */
  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false})
  isDeleted: boolean;

  /** Размер файла в КБ */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  size: number;

  /** Дата прикрепления */
  @jsonMember({constructor: Date, emitDefaultValue: false, isRequired: false})
  createDate: Date;

  getRowId() {
    return this.fileId;
  }

  setComment(comment: string): PitFile {
    this.comment = comment;
    return this;
  }

  setFileEntityId(entityId: number): PitFile {
    this.fileEntityId = entityId;
    return this;
  }

  constructor(fields?: Partial<PitFile>) {
    super();
    if (fields)
      Object.assign(this, fields);
  }

  public static fromLoadedFile(file: LoadedFile, fileTypeId: number, user?:PitUser): PitFile {
    return new PitFile({
      fileId: file.id,
      fileName: file.name,
      createDate: file.createDate,
      size: file.size,
      typeFileId: fileTypeId
    });
  }
}
